import { Box, Checkbox, FormControlLabel, Grid, Radio, Switch, alpha, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const Heading1 = styled.h1`
  color: #000;
  font-family: Roboto;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: 0.00938rem;
  margin: 0;
`
export const Heading2 = styled.h2<{ size?: number; }>`
  color: #000;
  font-family: Roboto;
  font-size: ${props => (props.size || 0.875) + 'rem'};
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  text-transform: uppercase;
  margin: 0;
`
export const BorderedBox = styled(Box)`
  border-radius: 0.25rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
`
export const ContentBox = styled(Box)<{ paddingTop?: number; paddingBottom?: number; borderSize?: number; }>`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: ${props => (props.paddingTop || 0.75) + 'rem'};
  padding-bottom: ${props => (props.paddingBottom || 0.75) + 'rem'};
  border-top: ${props => (props.borderSize || 0) + 'px solid rgba(0, 0, 0, 0.12)'};
`
export const GridLabel = styled(Grid)`
  color: #000;
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.375rem; 
`
export const GridValue = styled(Grid)`
  color: #000;
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
`
export const AlertContainer = styled.div`
  position: absolute;
  top: 4rem;
  left: 24rem;
  margin: 0 auto;
  z-index: 999;
`
export const PageLoaderContainer = styled.div`
  margin: 12rem auto auto auto;
  width: 21.875rem;
  text-align: center;
  background: #FFFFFF;
`
export const DestructiveActionIcon = styled.div`
  display: flex;
  padding: 0.625rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.625rem;
  border-radius: 1.8125rem;
  background: var(--semantic-error-shades-12-p, rgba(220, 38, 38, 0.12));
  width: 1.375rem;
`
export const EverifyIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
export const EverifyLabel = styled.span`
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
`
export const DialogHeader = styled.div`
  padding-top: 0.5rem;
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem; /* 133.333% */
  letter-spacing: 0.00938rem;
  align-self: stretch;
`
export const CustomDialogContent = styled.div`
  padding-top: 0.5rem;
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 150% */
  letter-spacing: 0.00938rem;
`
export const PackageFeatureContainer = styled.div`
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #D7D7D7;
`
export const FormI9Checkbox = styled(Checkbox)`
  padding: 0 0.75rem 0 0.5625rem;
`
export const FeatureCheckbox = styled(Checkbox)`
  padding: 0.375rem 0.75rem 0.375rem 0.5625rem;
`
export const PackageRadio = styled(Radio)`
  padding: 0.375rem 0.75rem 0.375rem 0.5625rem;
`
export const CCTFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    line-height: 18.75px;
    min-width: 400px;
  }
`
export const SwitchFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    line-height: 16px;
    font-weight: 400;
  }
`
export const CCTSwitch = muiStyled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    '&:hover': {
      backgroundColor: alpha('#0D1D38', theme.palette.action.hoverOpacity)
    },
    color: '#0D1D38'
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#0D1D38'
  }
}))